const ROLES = {
  ADMIN: { label: 'Admin', value: 'ADMIN' },
  CURATOR: { label: 'Curator', value: 'CURATOR' },
  QA: { label: 'Qa', value: 'QA' },
  TRAINEE: { label: 'Trainee', value: 'TRAINEE' },
  QA_TRAINEE: { label: 'QA Trainee', value: 'QA_TRAINEE' },
  QC_TRAINEE: { label: 'QC Trainee', value: 'QC_TRAINEE' },
  GUILD_LEAD: { label: 'Guild lead', value: 'GUILD_LEAD' },
  ML_DETECTIVE: { label: 'ML Detective', value: 'ML_DETECTIVE' },
  TRAINER: { label: 'Trainer', value: 'TRAINER' },
  QC: { label: 'Qc', value: 'QC' },
  SCRAPING: { label: 'Scraping', value: 'SCRAPING' },
}

export default ROLES
